import React from 'react';
import { reservasMock } from './mock';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';

export default function Reservas() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Reserva</TableCell>
            <TableCell>Hóspede</TableCell>
            <TableCell>Quarto</TableCell>
            <TableCell>Check-in</TableCell>
            <TableCell>Check-out</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reservasMock.map((r) => (
            <TableRow key={r.id} hover>
              <TableCell>{r.id}</TableCell>
              <TableCell>{r.hospede}</TableCell>
              <TableCell>{r.quarto}</TableCell>
              <TableCell>{r.checkin}</TableCell>
              <TableCell>{r.checkout}</TableCell>
              <TableCell>
                <Chip size="small" label={r.status} color={r.status === 'Confirmada' ? 'success' : r.status === 'Pendente' ? 'warning' : 'default'} />
              </TableCell>
              <TableCell align="right">{r.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
